import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const buyers = [{
  name: 'María',
  city: 'Buenos Aires',
  img: 'https://randomuser.me/api/portraits/women/44.jpg'
}, {
  name: 'Sofía',
  city: 'Córdoba',
  img: 'https://randomuser.me/api/portraits/women/68.jpg'
}, {
  name: 'Valentina',
  city: 'Rosario',
  img: 'https://randomuser.me/api/portraits/women/22.jpg'
}, {
  name: 'Camila',
  city: 'Mendoza',
  img: 'https://randomuser.me/api/portraits/women/12.jpg'
}, {
  name: 'Martina',
  city: 'La Plata',
  img: 'https://randomuser.me/api/portraits/women/33.jpg'
}, {
  name: 'Lucía',
  city: 'Tucumán',
  img: 'https://randomuser.me/api/portraits/women/41.jpg'
}, {
  name: 'Florencia',
  city: 'Mar del Plata',
  img: 'https://randomuser.me/api/portraits/women/55.jpg'
}, {
  name: 'Agustina',
  city: 'Salta',
  img: 'https://randomuser.me/api/portraits/women/29.jpg'
}];
export function SocialProofPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [currentBuyer, setCurrentBuyer] = useState(buyers[0]);
  useEffect(() => {
    const showInterval = setInterval(() => {
      const randomBuyer = buyers[Math.floor(Math.random() * buyers.length)];
      setCurrentBuyer(randomBuyer);
      setIsVisible(true);
      setTimeout(() => {
        setIsVisible(false);
      }, 4000);
    }, 12000); // Show every 12 seconds
    return () => clearInterval(showInterval);
  }, []);
  return <AnimatePresence data-id="element-249">
      {isVisible && <motion.div initial={{
      x: -300,
      opacity: 0
    }} animate={{
      x: 0,
      opacity: 1
    }} exit={{
      x: -300,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} className="fixed bottom-24 left-4 z-50 bg-black/90 border border-rosa/30 p-3 rounded-lg shadow-[0_0_15px_rgba(217,108,138,0.3)] flex items-center gap-3 max-w-[280px]" data-id="element-250">
          <img src={currentBuyer.img} alt={currentBuyer.name} className="w-12 h-12 rounded-full object-cover border-2 border-terracota" data-id="element-251" />
          <div data-id="element-252">
            <p className="text-xs text-white font-medium" data-id="element-253">
              <span className="font-bold text-rosa" data-id="element-254">{currentBuyer.name}</span>{' '}
              de {currentBuyer.city}
            </p>
            <p className="text-[10px] text-gray-300 mt-0.5" data-id="element-255">
              acaba de comprar este libro
            </p>
            <p className="text-[9px] text-terracota mt-1 font-bold" data-id="element-256">
              Hace unos minutos
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}